// import NiceSelect from './nice-select';

export default class formEffects {
    constructor() {

        const almennetForm = document.querySelectorAll('.almennet-form');

        almennetForm.forEach(form => {

            const almenNetLabel = form.querySelectorAll('label');

            const almenNetInput = form.querySelectorAll('input[type="text"],input[type="email"],input[type="tel"],textarea');

            const almenNetSelect = form.querySelectorAll('select');

            almenNetLabel.forEach(label => {
                label.addEventListener('click', e => {
                    e.preventDefault();
                });
            });

            almenNetInput.forEach(input => {
                input.addEventListener('click', e => {
                    e.preventDefault();
                    input.parentElement.parentElement.querySelector('label').classList.add('clicked');
                });
                input.addEventListener('keyup', e => {
                    e.preventDefault();
                    input.parentElement.parentElement.querySelector('label').classList.add('clicked');
                });
            });
            almenNetSelect.forEach(select => {
                // new NiceSelect(select, { searchable: false });
                select.addEventListener('click', e => {
                    e.preventDefault();
                    select.parentElement.parentElement.querySelector('label').classList.add('clicked');
                });
                select.addEventListener('keyup', e => {
                    e.preventDefault();
                    select.parentElement.parentElement.querySelector('label').classList.add('clicked');
                });
            });
        });
    }
}
